import type { ApiHook } from 'utils/request/useApi';

export function getExtensionLogs(
  api: ApiHook,
  extensionId: string,
  limit = 200,
): Promise<{ logs: string[] }> {
  return api.request({
    method: 'GET',
    url: `extensions/${extensionId}/logs?limit=${limit}`,
  });
}
